export const users = [
{
	username: '123',
	password: 123,
	user_balance: 10,
},
{
	username: '111',
	password: 111,
	user_balance: 20,
},
{
	username: '222',
	password: 222,
	user_balance: 30,
},
{
	username: '333',
	password: 333,
	user_balance: 40,
},
]
